import { SportModel } from "../..";
var sportOrderToHide = -4;
export var sportMapperFactory = function (countMapper, orders) {
    if (orders === void 0) { orders = []; }
    return function (sport) {
        return (new SportModel({
            id: sport.id || "",
            name: sport.name || "",
            order: cmsOrderMapper(sport, orders),
            numberOfEvents: countMapper(sport)
        }));
    };
};
export var preLiveCountMapper = function (sport) { return sport.fixturesCount || 0; };
export var liveCountMapper = function (sport) { return (sport.liveFixturesTotalCount || 0) + (sport.liveOutrightsTotalCount || 0); };
export var todayCountMapper = function (sport) { return sport.fixturesCount || 0; };
var cmsOrderMapper = function (sport, orders) {
    if (orders === void 0) { orders = []; }
    if (orders.length === 0) {
        return sport.order || 0;
    }
    var foundOrder = orders.find(function (o) { return "" + o.sportId === sport.id; });
    var result = foundOrder === undefined ? ((sport.order || 0) + 200) : foundOrder.activeInCms ? foundOrder.order : sportOrderToHide;
    return result;
};
//# sourceMappingURL=SportDataMapper.js.map